import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

// Holiday settings (holiday_settings + holiday_setting_detail) management
export const state = {
  holidaySettings: [],
  pagination: {
    totalPage: 0,
    currentPage: 1,
    totalRecord: 0,
    perPage: 10
  },
  // Default work times keyed by day of week ("Monday".."Sunday"), used to prefill hours
  workTimes: {}
};

export const getters = {
  holidaySettings: state => state.holidaySettings,
  pagination: state => state.pagination,
  workTimes: state => state.workTimes
};

export const mutations = {
  [types.HOLIDAY_SETTING.LIST_HOLIDAY_SETTING](state, data) {
    state.holidaySettings = data.data || [];
    state.pagination = {
      totalPage: data.last_page,
      currentPage: data.current_page,
      totalRecord: data.total,
      perPage: data.per_page
    };
  },
  [types.HOLIDAY_SETTING.SET_WORK_TIMES](state, data) {
    state.workTimes = data || {};
  }
};

export const actions = {
  async listHolidaySettings({ commit }, params) {
    const response = await axios.get(api.HOLIDAY_SETTINGS, { params });
    commit(types.HOLIDAY_SETTING.LIST_HOLIDAY_SETTING, response.data);
  },
  // eslint-disable-next-line
  async getHolidaySetting({ commit }, id) {
    const response = await axios.get(`${api.HOLIDAY_SETTINGS}/${id}`);
    return response.data;
  },
  // eslint-disable-next-line
  async createHolidaySetting({ commit }, data) {
    return axios.post(api.HOLIDAY_SETTINGS, data);
  },
  // eslint-disable-next-line
  async updateHolidaySetting({ commit }, { id, data }) {
    return axios.post(`${api.HOLIDAY_SETTINGS}/${id}`, data);
  },
  // eslint-disable-next-line
  async deleteHolidaySetting({ commit }, id) {
    return axios.delete(`${api.HOLIDAY_SETTINGS}/${id}`);
  },
  // Fetch once per session; work time settings rarely change
  async fetchWorkTimes({ commit, state }) {
    if (Object.keys(state.workTimes).length) return;
    const response = await axios.get(`${api.HOLIDAY_SETTINGS}/work-times`);
    commit(types.HOLIDAY_SETTING.SET_WORK_TIMES, response.data);
  }
};
